<template>
  <div class="bg-primary-500 min-h-screen">
    <div class="max-w-screen-xl mx-auto px-2 sm:px-6 lg:px-8 pt-24 pb-24">
      <div
        class="bg-white rounded-lg shadow px-6 py-8 max-w-lg mx-auto text-center"
      >
        <h2 class="text-2xl leading-8 font-extrabold text-gray-900">
          <span v-if="error">{{ $t('Payment failed') }}</span>
          <span v-else>{{ $t('Processing the transaction...') }}</span>
        </h2>
        <p v-if="error" class="mt-4 text-gray-600">{{ error }}</p>
        <div v-if="error" class="rounded-md shadow mt-6">
          <router-link
            class="btn text-white bg-primary-600 hover:bg-primary-500"
            :to="{ name: 'index', params: $route.params }"
          >
            {{ $t('Back to checkout') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
en:
  Payment failed: Payment failed
  Processing the transaction...: Processing the transaction...
  Back to checkout: Back to checkout
  amazonpayNotConfirmed: The Amazon Pay authorization was not completed.
  amazonpayMissingData: Your checkout session expired, please try again.

de:
  Payment failed: Zahlung fehlgeschlagen
  Processing the transaction...: Verarbeitung der Transaktion...
  Back to checkout: Zurück zum Checkout
  amazonpayNotConfirmed: Die Amazon Pay-Autorisierung wurde nicht abgeschlossen.
  amazonpayMissingData: Deine Checkout-Sitzung ist abgelaufen, bitte versuche es erneut.
</i18n>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { get, call } from 'vuex-pathify'

export default {
  name: 'AmazonpayReturn',

  data() {
    return {
      error: null
    }
  },

  computed: {
    publishableKey: get('checkout/publishableKey')
  },

  async mounted() {
    const clientSecret = this.$route.query.setup_intent_client_secret
    const redirectStatus = this.$route.query.redirect_status

    const checkoutData = await this.restoreCheckoutData()

    if (!clientSecret || !checkoutData) {
      this.error = this.$t('amazonpayMissingData')
      return
    }

    if (redirectStatus && redirectStatus !== 'succeeded') {
      this.error = this.$t('amazonpayNotConfirmed')
      return
    }

    await this.readKey({ rewardId: this.$route.params.rewardId })
    const stripe = await loadStripe(this.publishableKey)

    const { error, setupIntent } = await stripe.retrieveSetupIntent(
      clientSecret
    )

    if (error || setupIntent.status !== 'succeeded') {
      this.error = error ? error.message : this.$t('amazonpayNotConfirmed')
      return
    }

    const { sellerId, ...finalize } = checkoutData

    await this.finishSepa({
      ...finalize,
      pmId: setupIntent.payment_method
    })

    this.$router.push({
      name: 'successPageSepa',
      params: { sellerId, rewardId: this.$route.params.rewardId }
    })
  },

  methods: {
    readKey: call('checkout/readKey'),
    finishSepa: call('checkout/finishSepa'),
    restoreCheckoutData: call('amazonpay/restoreCheckoutData')
  }
}
</script>
